import React from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import { withCookies } from "react-cookie";
import * as actionTypes from "../../../store/actions/actionTypes";
import {
  getVendorCaseStudies,
  getVendorProfile,
  getVendorTestimonials,
  getVendorVideos,
  getVendorFAQ,
} from "../../Common/CommonMethods";

import PageMeta from "../../Common/PageMeta";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Loader from "../../Common/Loader/";
import VendorFooterPremium from "../../Common/Footer/VendorFooterPremium";
import { getCookie } from "../../Common/CommonMethods";
import { openAPI } from "../../../config";
import CanonicalSelfReference from "../../Common/CanonicalSelfReference";

//Refresh UI
import PremiumProfileRefresh from "./ProfilePremiumRefresh";
import ProfileVerifiedRefresh from "./ProfileVerifiedRefresh";

class VendorProfile extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    const { cookies } = props;
    this.state = {
      isDataLoaded: false,
      profileCustomerPathname: "/vendor/:id/customers",
    };
    this.getDataFromServer = this.getDataFromServer.bind(this);
    this.fetchCommonForVendor = this.fetchCommonForVendor.bind(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  UNSAFE_componentWillMount() {
    this._isMounted = true;
    if (this.props.vendorCommon.slug) {
      if (this.props.vendorCommon.slug !== this.props.match.params.id) {
        this.props.setSlugInCommonData(this.props.match.params.id);
        this.fetchCommonForVendor(this.props.match.params.id);
      } else {
        if (this._isMounted) {
          this.setState({ isDataLoaded: true });
        }
      }
    } else {
      this.props.setSlugInCommonData(this.props.match.params.id);
      this.fetchCommonForVendor(this.props.match.params.id);
    }
    if (this.props.match.path.includes("/vendor/:id")) {
      const regex = /\/all$/i;
      openAPI
        .put(
          `${process.env.REACT_APP_API_URL}${this.props.location.pathname
            .replace(regex, "")
            .replace("/customers", "")}/tab-click-log/p`,
          {},
          {
            withCredentials: true,
            headers: {
              "X-CSRFToken": `${getCookie("fc_react_csrfmiddlewaretoken")}`,
            },
          }
        )
        .then((response) => "")
        .catch((error) => {
          //refresh
        });
    }
  }

  componentDidCatch(error, errorInfo) {}

  fetchCommonForVendor = (vendorId) => {
    openAPI
      .get(`${process.env.REACT_APP_API_URL}/vendor/${vendorId}/common`, {
        withCredentials: true,
      })
      .then((resp) => {
        if (resp.data.status === 200) {
          //this.props.saveVendorCommonData(dummydata);
          this.props.saveVendorCommonData(resp.data);
          this.getDataFromServer(vendorId);
        } else if (Number(resp.data.status) === 301) {
          if (resp.data.show_no_results) {
            this.props.history.push(resp.data.url);
          } else {
            this.props.history.push(`/vendor/${resp.data.new_slug}`);
          }
        }
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.props.history.push(`/vendor/${vendorId}/no-match`);
        }
      });
  };

  // Original Call with less API hit
  // getDataFromServer = vendorId => {
  //   const { cookies } = this.props;

  //   axios.all([getVendorProfile(vendorId)]).then(
  //     axios.spread(vendorProfileData => {
  //       if (!vendorProfileData.data.visitor) {
  //         this.props.saveVendorProfileData({
  //           ...vendorProfileData.data,
  //         });
  //       }
  //       if (!!vendorProfileData.data.visitor) {
  //         if (
  //           !!vendorProfileData.data.visitor.method.email ||
  //           !!vendorProfileData.data.visitor.method.linkedin
  //         ) {
  //           this.props.saveVendorProfileData({
  //             ...vendorProfileData.data,
  //           });
  //         }
  //       }
  //       this.props.setVendorDataLoadedStatus();
  //       if (this._isMounted) {
  //         this.setState({ isDataLoaded: true });
  //       }
  //     })
  //   );
  // };

  getDataFromServer = (vendorId) => {
    const { cookies } = this.props;

    axios
      .all([
        getVendorProfile(vendorId),
        getVendorTestimonials(vendorId),
        getVendorCaseStudies(vendorId),
        getVendorVideos(vendorId),
        getVendorFAQ(vendorId),
      ])
      .then(
        axios.spread(
          (
            vendorProfileData,
            vendorTestimonialsData,
            vendorCaseStudiesData,
            vendorVideosData,
            vendorFAQData
          ) => {
            if (!vendorProfileData.data.visitor) {
              this.props.saveVendorProfileData({
                ...vendorProfileData.data,
              });
              this.props.saveVendorTestimonialsData({
                ...vendorTestimonialsData.data,
              });
              this.props.saveVendorCaseStudiesData({
                ...vendorCaseStudiesData.data,
              });
              this.props.saveVendorVideoData({
                ...vendorVideosData.data,
              });
            }
            if (!!vendorProfileData.data.visitor) {
              if (
                !!vendorProfileData.data.visitor.method.email ||
                !!vendorProfileData.data.visitor.method.linkedin
              ) {
                this.props.saveVendorProfileData({
                  ...vendorProfileData.data,
                });
                this.props.saveVendorTestimonialsData({
                  ...vendorTestimonialsData.data,
                  num_unblurred_reviews: -1,
                });
                this.props.saveVendorCaseStudiesData({
                  ...vendorCaseStudiesData.data,
                  num_unblurred_reviews: -1,
                });
                this.props.saveVendorVideoData({
                  ...vendorVideosData.data,
                  num_unblurred_reviews: -1,
                });
              }
            }
            let FAQData = { ...vendorFAQData.data };
            FAQData["results"] = FAQData.results.filter((obj) => !!obj.answer);
            this.props.saveVendorFAQData({ ...FAQData });
            this.props.setVendorDataLoadedStatus();
            if (this._isMounted) {
              this.setState({ isDataLoaded: true });
            }
          }
        )
      );
  };

  componentDidUpdate() {
    if (document.querySelector("body").className === "noscroll") {
      document.querySelector("body").className = "";
    }
    if (this.props.vendorCommon.slug) {
      if (this.props.vendorCommon.slug !== this.props.match.params.id) {
        this.props.resetVendorCommonData();
        this.props.setSlugInCommonData(this.props.match.params.id);
        this.fetchCommonForVendor(this.props.match.params.id);
      }
    } else {
      this.props.resetVendorCommonData();
      this.props.setSlugInCommonData(this.props.match.params.id);
      this.fetchCommonForVendor(this.props.match.params.id);
    }
  }

  getRenderComponent = () => {
    return this.props.vendorCommon.vendor_type === "premium" ? (
      //<ProfilePremium />
      <PremiumProfileRefresh />
    ) : (
      <ProfileVerifiedRefresh />
    );
  };

  getFooterComponent = () => {
    return <VendorFooterPremium />;
  };

  getPrerenderStatus = (isDataLoaded) => {
    return isDataLoaded ? (
      <Helmet>
        <script type="text/javascript">window.prerenderReady = true</script>
      </Helmet>
    ) : (
      <Helmet>
        <script type="text/javascript">window.prerenderReady = false</script>
      </Helmet>
    );
  };

  getPageMetaByPage = (props) => {
    return props.match.path === this.state.profileCustomerPathname ? (
      <PageMeta {...props.vendorCommon.vendorCustomers} />
    ) : (
      <PageMeta {...props.vendorProfile} {...props.vendorCommon} />
    );
  };

  getInPageBreadCrumbSchemaForProfile = (path) => {
    return path === "/vendor/:id" &&
      this.props.vendorProfile &&
      this.props.vendorProfile.breadcrumb_ld_schema ? (
      <script type="application/ld+json">
        {this.props.vendorProfile.breadcrumb_ld_schema}
      </script>
    ) : null;
  };

  getInPageBreadCrumbSchemaForCustomer = (path) => {
    return path === this.state.profileCustomerPathname &&
      this.props.vendorCommon &&
      this.props.vendorCommon.vendorCustomers &&
      this.props.vendorCommon.vendorCustomers.breadcrumb_ld_schema ? (
      <script type="application/ld+json">
        {this.props.vendorCommon.vendorCustomers.breadcrumb_ld_schema}
      </script>
    ) : null;
  };

  getInPageWebsiteSchemaForCustomer = (path) => {
    return path === this.state.profileCustomerPathname &&
      this.props.websiteCommon &&
      this.props.websiteCommon.common_seo_schema &&
      this.props.websiteCommon.common_seo_schema.website_ld_schema ? (
      <script type="application/ld+json">
        {this.props.websiteCommon.common_seo_schema.website_ld_schema}
      </script>
    ) : null;
  };

  getInPageCorporationSchemaForCustomer = (path) => {
    return path === this.state.profileCustomerPathname &&
      this.props.vendorCommon &&
      this.props.vendorCommon.corporation_ld_schema ? (
      <script type="application/ld+json">
        {this.props.vendorCommon.corporation_ld_schema}
      </script>
    ) : null;
  };

  render() {
    return (
      <React.Fragment>
        <CanonicalSelfReference />
        {this.getPrerenderStatus(this.state.isDataLoaded)}
        {Object.keys(this.props.vendorProfile).length > 0 &&
        this.props.vendorCommon.isDataLoaded &&
        this.state.isDataLoaded ? (
          <React.Fragment>
            {this.getPageMetaByPage(this.props)}
            {this.getRenderComponent()}
            {this.getFooterComponent()}
            {this.getInPageBreadCrumbSchemaForProfile(this.props.match.path)}
            {this.getInPageBreadCrumbSchemaForCustomer(this.props.match.path)}
            {this.getInPageWebsiteSchemaForCustomer(this.props.match.path)}
            {this.getInPageCorporationSchemaForCustomer(this.props.match.path)}
          </React.Fragment>
        ) : (
          <Loader />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vendorCommon: state.vendorCommon,
    vendorProfile: state.vendorProfile,
    websiteCommon: state.webSiteCommonData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveVendorCommonData: (data) =>
      dispatch({ type: actionTypes.SAVE_VENDOR_COMMON_DATA, payload: data }),
    saveVendorProfileData: (data) =>
      dispatch({ type: actionTypes.SAVE_VENDOR_PROFILE_DATA, payload: data }),
    saveVendorTestimonialsData: (data) =>
      dispatch({
        type: actionTypes.SAVE_VENDOR_TESTIMONIAL_DATA,
        payload: data,
      }),
    saveVendorCaseStudiesData: (data) =>
      dispatch({
        type: actionTypes.SAVE_VENDOR_CASESTUDIES_DATA,
        payload: data,
      }),
    saveVendorVideoData: (data) =>
      dispatch({ type: actionTypes.SAVE_VENDOR_VIDEOS_DATA, payload: data }),
    saveVendorCustomersData: (data) =>
      dispatch({ type: actionTypes.SAVE_VENDOR_CUSTOMERS_DATA, payload: data }),
    saveVendorFAQData: (data) =>
      dispatch({ type: actionTypes.SAVE_VENDOR_FAQ_DATA, payload: data }),
    setSlugInCommonData: (data) =>
      dispatch({
        type: actionTypes.SET_VENDOR_COMMON_DATA_SLUG,
        payload: data,
      }),
    setVendorDataLoadedStatus: () =>
      dispatch({
        type: actionTypes.SET_VENDOR_DATA_LOADED_TRUE,
      }),
    resetVendorCommonData: () =>
      dispatch({
        type: actionTypes.RESET_VENDOR_COMMON_DATA,
      }),
    resetVendorProfileData: () =>
      dispatch({
        type: actionTypes.RESET_VENDOR_PROFILE_DATA,
      }),
    resetVendorTestimonialsData: () =>
      dispatch({
        type: actionTypes.RESET_VENDOR_TESTIMONIAL_DATA,
      }),
    resetVendorCaseStudiesData: () =>
      dispatch({
        type: actionTypes.RESET_VENDOR_CASESTUDIES_DATA,
      }),
    resetVendorVideosData: () =>
      dispatch({
        type: actionTypes.RESET_VENDOR_VIDEOS_DATA,
      }),
    setTestimonialFilterTrue: () =>
      dispatch({
        type: actionTypes.SET_TESTIMONIAL_FILTER_TRUE,
      }),
    setTestimonialFilterFalse: () =>
      dispatch({
        type: actionTypes.SET_TESTIMONIAL_FILTER_FALSE,
      }),
    updateLeadGenStatus: () => {
      dispatch({ type: actionTypes.UPDATE_LEADGEN_STATUS, status: false });
    },
  };
};

const VendorProfileWithRouter = withRouter(withCookies(VendorProfile));

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorProfileWithRouter);
